import type { CreateSensorFromUnknownPayload } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { sensorsQueryKey } from './useSensors';

export default function useCreateSensorFromUnknown() {
  const qc = useQueryClient();
  return useMutation<{ sensorId: string }, Error, CreateSensorFromUnknownPayload>({
    mutationFn: (payload) => callFunction<CreateSensorFromUnknownPayload, { sensorId: string }>('createSensorFromUnknownCallable', payload),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: sensorsQueryKey(vars.homeId) });
      void qc.invalidateQueries({ queryKey: ['homeAutomation', 'unknownSensors', vars.homeId] });
      toast.success('Sensor created.');
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to create sensor.');
    },
  });
}
